import { cloneElement } from "react";
import { MainContainer } from "styled/common";

const Main = ({ children, className = "", ...allOtherProps }) => {
  const wrapperClassName = `main-layout ${className}`;
  return (
    <MainContainer className={wrapperClassName}>
      {cloneElement(children, { ...allOtherProps })}
    </MainContainer>
  );
};

export default Main;
